import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Allocations_ds_get_allocation_configurationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, Priority?: number, Scope?: string, Filters?: { Id?: number, Name?: string, Value?: string }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Allocations/datasources/ds_get_allocation_configuration/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, Priority?: number, Scope?: string, Filters?: { Id?: number, Name?: string, Value?: string }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Allocations/datasources/ds_get_allocation_configuration/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, Priority?: number, Scope?: string, Filters?: { Id?: number, Name?: string, Value?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Allocations/datasources/ds_get_allocation_configuration/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number    }) {
      return false;
    }
}
